import React from "react";
import { Typography } from "@mui/material";

interface ParagraphShowActionProps {
  action_value?: any;
  result?: any;
}

export default function ParagraphShowAction({ action_value, result }: ParagraphShowActionProps) {
  return (
    <>
      {action_value && action_value.map((action: any, index: number) => {
        return (
          <div key={index} style={{ display: 'flex', marginBottom: '10px', flexDirection: 'column' }}>
            <Typography sx={{ fontWeight: 'bold', marginRight: '20px' }}>
              {action.config_details.value.title}: 
            </Typography>
            {action.config_details.default_value ? (
              <div 
                dangerouslySetInnerHTML={{ __html: action.config_details.default_value.replace(/<font[^>]*>/gi, '<span>').replace(/<\/font>/gi, '</span>') }}
                style={{ 
                  fontFamily: 'Poppins',
                  fontSize: '14px',
                  lineHeight: '1.6'
                }}
              />
            ) : (
              <p>Content not available.</p>
            )}
          </div>
        );
      })}
    </>
  );
}